<mat-toolbar color="primary" [style.background-color]="navBarBackground" [style.color]="navBarText">
  <a class="title" routerLink="/"><span class="logo"></span></a>
</mat-toolbar>

<main class="app-main" [style.background-color]="background">
  <router-outlet></router-outlet>
  <div kendoDialogContainer></div>
</main>
